/**
 * Custom schema for footer text
 * Automatically positions footer at bottom of page
 */

/**
 * Draw footer text at bottom of page
 */
async function drawFooter(arg: {
  pdfDoc: import("pdf-lib").PDFDocument;
  page: import("pdf-lib").PDFPage;
  schema: {
    position: { x: number; y: number };
    width: number;
    height: number;
  };
  value: string;
}): Promise<void> {
  const { rgb, StandardFonts } = await import("pdf-lib");
  const { value } = arg;

  if (!value || value.trim().length === 0) {
    return;
  }

  const { x, y } = arg.schema.position;
  const pageHeight = arg.page.getHeight();

  // Convert mm to points
  const MM_TO_PT = 2.83465;
  const startX = x * MM_TO_PT;

  // In pdfme templates, Y coordinates are from top (Y=0 is top)
  // But when rendering with pdf-lib, we need PDF coordinates (Y=0 is bottom)
  // The schema position y is in mm from top, so we convert:
  // PDF Y = pageHeight - (y * MM_TO_PT)
  const schemaYInPoints = y * MM_TO_PT;
  const pdfY = pageHeight - schemaYInPoints;

  const font = await arg.pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontSize = 10.5; // FONT.SMALL

  // Draw text at bottom left
  // Position text so baseline is at the calculated Y position
  arg.page.drawText(value, {
    x: startX,
    y: pdfY - fontSize, // Position text with baseline at calculated position
    size: fontSize,
    font,
    color: rgb(0.4, 0.4, 0.4), // Gray color
  });
}

export const footerSchema = {
  ui: (arg: { rootElement: HTMLElement; value: string }) => {
    const div = document.createElement("div");
    div.style.width = "100%";
    div.style.height = "100%";
    div.style.display = "flex";
    div.style.alignItems = "flex-end"; // Align to bottom
    div.style.fontSize = "10.5px";
    div.style.color = "#666";
    div.textContent = arg.value || "";
    arg.rootElement.appendChild(div);
  },

  pdf: drawFooter,

  propPanel: {
    schema: {},
    defaultSchema: {
      name: "footer",
      type: "footer",
      position: { x: 0, y: 0 },
      width: 190,
      height: 5,
    },
    defaultValue: "",
  },
};

export default footerSchema;
